/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState, useContext} from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import {FluidContainer, SimpleTabs, TableAccExamsPlayer, TableTrainingPlayer} from '../../../components';
import {ARMcontext} from '../../../utils/context/context';
import {Teams} from '../../../utils/api';
import {RadiosContainer, TableWrapper, RadiosWrapper} from '../styles';
import { Loader } from '../../../components';
import { URL_ACCOUNTABILITY } from '../../../utils/constants/routes';

const TableDefaultTabs = [
  {
    title: 'TRAINING',
    url: 'training',
    icon: '',
    action: () => {},
  },
  {
    title: 'EXAMS',
    url: 'exams',
    icon: '',
    action: () => {},
  },
];

export default ({playersGroup, playerNameSearch}: {playersGroup: string; playerNameSearch: string}) => {
  const [exams, useExams] = useState<Array<object | any>>([]);
  const {selectedPlayer, HandleToastMessage} = useContext(ARMcontext);
  const {selectedTeam} = useContext(ARMcontext);
  const [loadingTable, setLoadingTable] = useState(true);
  const TEAMS = new Teams();
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    getAccountabilityExams(selectedPlayer);
  }, [playersGroup, selectedTeam, playerNameSearch, selectedPlayer]);
  async function getAccountabilityExams(selectedPlayer) {
    try {
      const examsResponse = await TEAMS.GetAccountabilityExams(selectedTeam._id, playersGroup, playerNameSearch);
      const player = examsResponse.data.records.filter(x => x._id === selectedPlayer._id)
      if (examsResponse.status) {
        useExams(player);
        setLoadingTable(false);
      }
    } catch (error) {
      console.error('Error getting accountability exams', error);
      setLoadingTable(false);
      HandleToastMessage('An error ocurred loading accountability', true, 2000, 'error');
    }
  }
  useEffect(() => {
    if(location.pathname !== URL_ACCOUNTABILITY.EXAMS && location.pathname !== URL_ACCOUNTABILITY.TRAINING){
      navigate('/players/accountability/training');
    }
  }, [history]);
  return (
    <FluidContainer>
      <RadiosWrapper alignItems='center'>
        <RadiosContainer data-cy="accountability-navigation">
          <SimpleTabs dataArray={TableDefaultTabs} url={'/players/accountability'} />
        </RadiosContainer>
      </RadiosWrapper>
      <TableWrapper>
      {loadingTable ?
            <div style={{ width: '100%', display: 'block', alignItems: 'center' }}>
              <Loader height="90px" />
            </div> :
            <>
                    {window.location.href.includes('/accountability/exams') && <TableAccExamsPlayer dataTableContent={exams} />}
                    {window.location.href.includes('/accountability/training') && <TableTrainingPlayer dataTableContent={exams} />}
                    </>
            }

      </TableWrapper>
    </FluidContainer>
  );
};
